import {
  apiDocumenterImage,
  shopAnywhereImage,
  twitterHelpdeskImage,
  graphqlAppImage,
  bankSettlementSystemImage,
  ApiIcon,
  TwitterIcon,
  ShopIcon,
  GraphQLAppIcon,
  FastAPIIcon,
  fastapiAppImage,
  goEventsApiImage,
  expenseTrackingExpenseMgmtApi,
} from "assets/Images";
import { filterInSameOrder } from "utils/functions";
import { techListArray, techListMap } from "./techList";

/* *********************************************************************************************************** */
/* *********************************************************************************************************** */

const allProjectsList = [
  {
    name: "Bank Settlement System",
    show: true,
    sortOrder: 1,
    icon: null,
    overviewImg: bankSettlementSystemImage,
    iconSize: "",
    duration: `Oct 2025`,
    techList: filterInSameOrder(techListArray, ["golang", "postgresql", "grpc", "kafka", "docker"]),
    description: `A microservices-based financial transaction system that simulates how real-world payment networks process, capture, and settle payments.`,
    externalUrls: [
      {
        type: "website",
        url: `https://github.com/parasagrawal71/bank-settlement-system/blob/main/README.md`,
      },
      {
        type: "github",
        url: `https://github.com/parasagrawal71/bank-settlement-system`,
        iconSize: "23px",
      },
    ],
  },
  {
    name: "Twitter Helpdesk",
    show: true,
    sortOrder: 2,
    icon: TwitterIcon,
    overviewImg: twitterHelpdeskImage,
    iconSize: "28px",
    duration: `Nov 2020`,
    techList: filterInSameOrder(techListArray, [
      "javascript",
      "vuejs",
      "nodejs",
      "websocket",
      "html",
      "css",
      "sass",
      "git",
      "api",
      "docker",
    ]),
    description: `An application that displays all the tweets in which someone is
      mentioned in one place. OAuth login. Mention and reply in real-time
      without refreshing the page (WebSockets).`,
    externalUrls: [
      {
        type: "demovideo",
        url: "/demo-videos/Twitter_Helpdesk_tested_with_two_ids.mp4",
        // url: `https://drive.google.com/uc?id=10yPXMO4IyYN8l1xC6_fzNEaGxLOrtCc_`,
        isVideo: true,
      },
      {
        type: "website",
        url: `https://twitter-helpdesk-app.web.app/`,
      },
      {
        type: "github",
        url: `https://github.com/parasagrawal71/twitter-helpdesk`,
        iconSize: "23px",
      },
    ],
  },
  {
    name: "API Documenter",
    show: false,
    sortOrder: 3,
    icon: ApiIcon,
    overviewImg: apiDocumenterImage,
    iconSize: "32px",
    duration: `Apr - June 2021`,
    techList: filterInSameOrder(techListArray, [
      "javascript",
      "react",
      "nodejs",
      "expressjs",
      "mongo",
      "html",
      "css",
      "sass",
      "git",
      "api",
      "materialUi",
      "docker",
    ]),
    description: `An application for documenting all APIs for all microservices in an
    organization. One can also call the API from here and see the results.
    It provides controls to maintain different levels of access to a user
    for a microservice.`,
    externalUrls: [
      {
        type: "demovideo",
        url: "/demo-videos/API_Documenter_Application_Demo.mp4",
        // url: `https://drive.google.com/uc?id=1oqpiK_GMw-hmTxofoCppJiHeh9y7X5y7`,
        isVideo: true,
      },
      {
        type: "website",
        url: `https://api-documenter.web.app`,
      },
      {
        type: "github",
        url: `https://github.com/parasagrawal71/api-documenter`,
        iconSize: "23px",
      },
    ],
  },
  {
    name: "Expense Tracking",
    show: true,
    sortOrder: 4,
    icon: null,
    overviewImg: expenseTrackingExpenseMgmtApi,
    iconSize: "",
    duration: `Feb 2025`,
    techList: filterInSameOrder(techListArray, [
      "nestjs",
      "typescript",
      "postgresql",
      "graphql",
      "typeorm",
    ]),
    description: `A modular monorepo built with Nest.js and pnpm workspaces, designed to manage expenses efficiently. It follows a microservices architecture with dedicated services for authentication and expense management.`,
    externalUrls: [
      {
        type: "website",
        url: `https://github.com/parasagrawal71/expense-tracking/blob/master/README.md`,
      },
      {
        type: "github",
        url: `https://github.com/parasagrawal71/expense-tracking`,
        iconSize: "23px",
      },
    ],
  },
  {
    name: "Shop Anywhere",
    show: false,
    sortOrder: 5,
    icon: ShopIcon,
    overviewImg: shopAnywhereImage,
    iconSize: "30px",
    duration: `Apr - Sep 2020`,
    techList: filterInSameOrder(techListArray, [
      "javascript",
      "react",
      "redux",
      "nodejs",
      "expressjs",
      "mongo",
      "html",
      "css",
      "sass",
      "git",
      "api",
      "materialUi",
    ]),
    description: `Built a simple e-commerce website to learn and apply different
      concepts from React, Redux, NodeJS, and Mongo. This project was
      my experiment to learn good folder structure, git best practices like
      branch naming conventions, reusable and configurable components,
      CSS best practices such as BEM naming conventions, and more.`,
    externalUrls: [
      {
        type: "website",
        url: `https://shop-anywhere.web.app/`,
      },
      {
        type: "github",
        url: `https://github.com/parasagrawal71/shop-anywhere`,
        iconSize: "23px",
      },
    ],
  },
  {
    name: "Go Events API",
    show: true,
    sortOrder: 6,
    icon: null,
    overviewImg: goEventsApiImage,
    iconSize: "",
    duration: `Sep 2025`,
    techList: filterInSameOrder(techListArray, ["golang", "postgresql"]),
    description: `A RESTful API built with GoLang, providing secure authentication (register & login) endpoints and full CRUD operations for event management. Implements structured request validation, token-based authentication, and clean architecture principles.`,
    externalUrls: [
      {
        type: "website",
        url: `https://github.com/parasagrawal71/go-events-api/blob/master/README.md`,
      },
      {
        type: "github",
        url: `https://github.com/parasagrawal71/go-events-api`,
        iconSize: "23px",
      },
    ],
  },
  {
    name: "GraphQL App",
    show: true,
    sortOrder: 7,
    icon: GraphQLAppIcon,
    overviewImg: graphqlAppImage,
    iconSize: "30px",
    iconColor: "#C52E95",
    duration: `May 2023`,
    techList: filterInSameOrder(techListArray, [
      "graphql",
      "javascript",
      "nodejs",
      "mongo",
      "docker",
    ]),
    description: `A server based on GraphQL that provides the capability to perform queries on posts, comments related to the posts, and users. Additionally, it allows one to add new users and modify existing user data.`,
    externalUrls: [
      {
        type: "website",
        url: `https://graphql-app-enrf.onrender.com/graphql`,
      },
      {
        type: "github",
        url: `https://github.com/parasagrawal71/graphql-app`,
        iconSize: "23px",
      },
    ],
  },
  {
    name: "FastAPI App",
    show: true,
    sortOrder: 8,
    icon: FastAPIIcon,
    overviewImg: fastapiAppImage,
    iconSize: "30px",
    iconColor: "#009688",
    duration: `July 2023`,
    techList: filterInSameOrder(techListArray, [
      "fastapi",
      "python",
      "mongo",
      "docker",
      "googlecloud",
    ]),
    description: `A FastAPI-based CRUD application.`,
    externalUrls: [
      {
        type: "website",
        url: `https://fastapi-app-l1dx.onrender.com/docs`,
      },
      {
        type: "github",
        url: `https://github.com/parasagrawal71/fastapi-app`,
        iconSize: "23px",
      },
    ],
  },
];

allProjectsList.sort((p1, p2) => p1.sortOrder - p2.sortOrder);
const projectsList = allProjectsList.filter((p) => p.show);
const techFilters = Object.values(techListMap);

export { projectsList, techFilters };
